<template>
  <div class="invio-pdc-container">
    <div class="card">
      <div class="flex justify-content-between align-items-center mb-4">
        <h4 class="m-0">Invio PDC - Portale delle Pratiche</h4>
        <Dropdown 
          v-model="selectedPratica" 
          :options="tipologiePratiche" 
          optionLabel="label" 
          placeholder="Seleziona tipo pratica"
          class="w-20rem"
          @change="onPraticaChange"
        />
      </div>

      <!-- Caricamento dinamico del componente in base alla pratica selezionata -->
      <component :is="currentComponent" v-if="currentComponent" />

      <!-- Stato iniziale: nessuna pratica selezionata -->
      <div v-else class="text-center p-5">
        <i class="pi pi-info-circle" style="font-size: 4rem; color: #2196F3; opacity: 0.5;"></i>
        <h5 class="mt-3 text-muted">Seleziona un tipo di pratica per iniziare</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import SospensioniPage from './pages/SospensioniPage.vue';
import RiattivazioniPage from './pages/RiattivazioniPage.vue';

export default {
  name: 'InvioPDC',
  components: {
    SospensioniPage,
    RiattivazioniPage
  },
  setup() {
    const selectedPratica = ref(null);
    const tipologiePratiche = ref([
      { value: 'sospensioni', label: 'Sospensioni (SM1)', code: 'SM1' },
      { value: 'riattivazioni', label: 'Riattivazioni (RT1)', code: 'RT1' }
    ]);

    const currentComponent = computed(() => {
      if (!selectedPratica.value) return null;

      const componentMap = {
        'sospensioni': 'SospensioniPage',
        'riattivazioni': 'RiattivazioniPage'
      };

      return componentMap[selectedPratica.value.value] || null;
    });

    const onPraticaChange = () => {
      // Il cambio di pratica ricaricherà automaticamente il componente corretto
    };

    return {
      selectedPratica,
      tipologiePratiche,
      currentComponent,
      onPraticaChange
    };
  }
};
</script>

<style scoped>
.invio-pdc-container {
  padding: 1rem;
}

.card {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.text-muted {
  color: #6c757d;
}
</style>
